import { NgFor, NgIf } from '@angular/common';
import { Component, inject } from '@angular/core';
import { AppInformationService } from 'app/core/app-information.service';
import { AuthService, GenesisUnitOfWork } from 'app/core/core.module';
import { PartConfigModelType, PartConfigWinchStand, PartConfigWinchStandOption } from 'app/core/model/entity-model';
import { PartConfigModelSize } from 'app/core/model/part-config-model-size';
import { DxFormModule } from 'devextreme-angular';
import validationEngine from 'devextreme/ui/validation_engine';
import { BsModalService } from 'ngx-bootstrap/modal';
import { Subject } from 'rxjs';

@Component({
    imports: [NgIf, NgFor, DxFormModule],
    selector: 'app-mso-dialog',
    template: `
        <div class="modal-header">
            <h2 class="modal-title">Duplicate MSO</h2>
        </div>
        <div class="d-flex" style="align-items: flex-start;">
            <div class="flex-fill d-flex flex-column">
                <div class="card">
                    <div class="card-body">
                        <dx-form *ngIf="filter" [formData]="filter" validationGroup="validationGroup">
                            <dxi-item itemType="group">
                                <dxi-item dataField="dealerName" [editorOptions]="{ disabled: true }">                                </dxi-item>
                                <dxi-item dataField="price" [label]="{ text: 'Price (ea)' }" editorType="dxNumberBox" [editorOptions]="{ step: 0, format: { type: 'currency', precision: 2 }, width: '150px' }">
                                    <dxi-validation-rule type="required"> </dxi-validation-rule>
                                    <dxi-validation-rule type="range" [min]="0"> </dxi-validation-rule>
                                </dxi-item>
                                <dxi-item dataField="notes" [label]="{ text: 'Notes (optional)' }" editorType="dxTextArea" [editorOptions]="{ height: '100px' }" [colSpan]="3">
                                </dxi-item>
                            </dxi-item>
                        </dx-form>
                        <div class="d-flex">
                            <div class="d-flex flex-column ms-3 me-3">
                                <table class="mt-3 table table-hover table-min-width">
                                    <thead>
                                        <tr>
                                            <th>Selected VINs</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr *ngFor="let vin of vins">
                                            <td>{{ vin }}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="modal-footer">
            <button class="btn btn-danger" (click)="save()">Save</button>
            <button class="btn btn-success" (click)="close()">Close</button>
        </div>
    `,
    styles: `
        .table-min-width {
            min-width: 150px;
        }
    `,
    standalone: true,
})
export class MsoDialogComponent {
    appInfo = inject(AppInformationService);
    auth = inject(AuthService);
    uow = inject(GenesisUnitOfWork);
    modalService = inject(BsModalService);

    result = new Subject<{ success: boolean; value: any }>();
    vins: string[] = [];
    filter: any = {};
dealerName: string;

    modelTypes: PartConfigModelType[];
    modelType: PartConfigModelType;
    modelSize: PartConfigModelSize;
    winchStands: PartConfigWinchStand[];
    allWinchStandOptions: PartConfigWinchStandOption[];
    winchStandOptions: PartConfigWinchStandOption[];
    modelSizes: PartConfigModelSize[];
    selectedModelSizeIds: number[];
    displayOrder: number;
    validationGroup: 'validationGroup';
    canChangeModelType = false;
    isNew = false;
    salesAddons: any[] = [];



    async ngOnInit() {
        this.filter = {
            dealerName: this.dealerName,
            price: 25.00,
            notes: '',
        };
    }


    async save() {
        if (!this.validate()) return;
        this.result.next({ success: true, value: this.filter } as any);
    }

    close() {
        this.uow.rollback();
        this.result.next({ success: false, value: null } as any);
    }

    validate() {
        const groupConfig = validationEngine.getGroupConfig('validationGroup');
        if (groupConfig) {
            const result = validationEngine.validateGroup('validationGroup');
            if (!result.isValid) {
                let message = '';
                result.brokenRules.forEach((brokenRule) => {
                    if (brokenRule.type === 'custom') message = `${brokenRule.message}\n${message}`;
                });
                this.appInfo.notifyToast(`Please fix errors before saving.\n\n${message}`, 'error');
                return false;
            }
        }
        return true;
    }
}
